import Flickity from 'flickity'
import { parseJSON } from '@/components/helpers/utils'
const defaultOptions = {
  contain: true
}
export class Carousel extends HTMLElement {
  connectedCallback() {
    const options = this.carouselSettings
    options.cellSelector = '&:not(style)'
    this.flickity = new Flickity(this, { ...defaultOptions, ...options })
  }

  observedAttributes = ['carousel-settings']

  get carouselSettings() {
    const carouselSettings = this.getAttribute('carousel-settings')
    if (!carouselSettings) return {}
    const parsedSettings = parseJSON(carouselSettings)
    // Handle groupCells value conversion
    if (parsedSettings?.groupCells !== undefined) {
      const value = parsedSettings.groupCells

      // Convert string 'true'/'false' to boolean
      if (value === 'true') {
        parsedSettings.groupCells = true
      } else if (value === 'false') {
        parsedSettings.groupCells = false
        // Convert numeric string to number
      } else if (!isNaN(value) && typeof value === 'string') {
        parsedSettings.groupCells = Number(value)
      }
    }
    return parsedSettings
  }

  disconnectedCallback() {
    if (this.flickity) {
      this.flickity.destroy()
    }
  }
}
